import {SlideActions} from '../redux_constants/slides.constant';
import {
    addSlidesToPoller,
    changeTotal,
    changeTotalNumberOfPages,
    clearAndAddSlidesToPoller,
    removeSlidesFromPoller
} from "./dashboard.action"
import {searchFailed, searchInitiated, toggleDefaultOrderUsed} from "./search.action"
import {setUIBusy, setUIIdle} from './utils.action';
import {SearchAlertConstant} from "../redux_constants/search.constant";
import {DashboardConstants} from "../redux_constants/dashboard.constant";
import {message} from "antd";
import {call, delay, put, race} from 'redux-saga/effects'
import cookie from "react-cookies";
import querystring from "query-string";
import {get, get_response, patch, post_response, put_response} from "../helper/request";
import {error_manager} from "../helper/error_manager";
import {isNull, isTrue} from "../utils/utils";
import {slideExportStatus, slideTilingStatus, slideUploadStatus, specimenType, scanSpeed} from "../utils/const";

export const allSlidesLoadingSuccess = (success) => (dispatch) => {
    dispatch({
        type: SlideActions.ALL_SLIDES_UPDATE_SUCCESS,
        response: success
    });
    dispatch(changeTotalNumberOfPages(success.data.total_pages));
    dispatch(changeTotal(success.data.count));
}

export const slideListUpdateInitiated = (id) => ({
    type: SlideActions.SLIDE_LIST_UPDATE_INITIATED,
    id: id
})

export const slideListUpdateSuccess = (id, updatedInfo) => ({
    type: SlideActions.SLIDE_LIST_UPDATE,
    updatedInfo: updatedInfo,
    id: id
})

export const setSlideListFetched = (id) => ({
    type: SlideActions.SET_SLIDE_LIST_ITEM_FETCHED,
    id: id
})

export const slideListDeleteSuccess = (id) => ({
    type: SlideActions.SLIDE_LIST_DELETE,
    id: id
})

export const slideListUpdateFailed = (id, error) => ({
    type: SlideActions.SLIDE_LIST_UPDATE_FAILED,
    response: error,
    id: id
})

export const slideStatusFetched = (id, data) => ({
    type: SlideActions.SLIDE_STATUS_UPDATED,
    status: data,
    id: id,
})

export const setAnalysisFilter = (key, checked) => ({
    type: DashboardConstants.SET_ANALYSIS_FILTER_BOOL,
    key: key,
    checked: checked
})

export const slideUpdateAlert = (id, value) => (dispatch) => {
    dispatch(slideListUpdateInitiated(id));
    let url = `/api/slide/${id}/`
    put_response(url, value)
        .then(response => {
            if (response.status === 200 || response.status === 301 || response.status === 302) {
                response.data.displayOrder = value.displayOrder;
                dispatch(slideListUpdateSuccess(id, response.data));
            }
            else if (response.status === 403 || response.status === 401 || response.status === 400) {
                dispatch(slideListUpdateFailed(id, response));
            }
        })
        .catch(err => {
            dispatch(slideListUpdateFailed(id, err));
        });
}

export const descUpdateAlert = (id, value, displayOrder) => (dispatch) => {
    dispatch(slideListUpdateInitiated(id));
    let url = `/api/add_desc/`;
    let val = {"desc": value, "slide_id" : id};
    post_response(url, querystring.stringify(val))
        .then(response => {
            if (response.status === 200 || response.status === 301 || response.status === 302) {
                response.data.displayOrder = displayOrder;
                dispatch(slideListUpdateSuccess(id, response.data));
                message.success('Slide Update Successful', 2.5);
            }
            else if (response.status === 403 || response.status === 401 || response.status === 400) {
                dispatch(slideListUpdateFailed(id, response));
                message.success('Slide Update Failed', 2.5);
            }
        })
        .catch(err => {
            dispatch(slideListUpdateFailed(id, err));
        });
}

export const getAdjacentSlides = (id, successCallback) => dispatch => {
    const url = `/api/get_adjacent_slides/?slide_id=` + id + "&morpheus_setting_id="
        + JSON.parse(localStorage.getItem('morpheus_setting')).id;
    get(url)
        .then(result => successCallback(result))
        .catch(err => {
            console.error("GET_ADJACENT_SLIDE_ERROR: ", err);
            message.error("Failed to load adjacent slides")
        })

}

export const loadSlides = (partsOfUrl) => dispatch => {
    dispatch(searchInitiated());
    dispatch(toggleDefaultOrderUsed(true));

    var encodedUrl = urlEncoder(partsOfUrl);
    let url = `/api/slide/` + encodedUrl;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                dispatch(allSlidesLoadingSuccess(response));
                dispatch({
                    type: SearchAlertConstant.UPDATE_URL_STATE,
                    urlState: {
                        ...partsOfUrl,
                        isFetching: false,
                        page: response.data.page_number,
                        numPages: response.data.total_pages,
                        total: response.data.count,
                    },
                });
                let ids_to_poll = response.data.results.map(slide => slide.id);
                dispatch(clearAndAddSlidesToPoller(ids_to_poll));
                isTrue(cookie.load("superuser")) && dispatch(loadScanAnalysisData(ids_to_poll));
            }
            else {
                dispatch(searchFailed(response));
            }
        })
        .catch(err => {
            dispatch(searchFailed(err));
            console.error("ERROR: ", err)
			message.error('Slides not found');
        })
}

export const loadScanAnalysisData = (slide_ids) => dispatch => {
    // slide_ids is an array of slide_id, eg: ["207bce9f93fc4ed6838f1c3e4e25089c", "55217c383b1a487e861cb21fde07b8ba"]
    let url = `/api/scan_analysis_data/`;

    post_response(url, querystring.stringify({'slide_ids': slide_ids.join(",")}))
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: SlideActions.SLIDE_SCAN_ANALYSIS_DATA_FETCH_SUCCESS,
                    data: response.data
                });
                dispatch({
                    type: DashboardConstants.UPDATE_ANALYSIS_KEYS,
                    data: response.data
                });
            } else {
                // TODO: handle
                console.error("failed to get scan analysis data", response.status, response);
            }
        })
        .catch(err => {
            // TODO: handle
            console.error("failed to get scan analysis data", err);
        })
}

export const changeSlideOwner = (slide, owner) => dispatch => {
    dispatch(setUIBusy());
    patch(`/api/slide/${slide.id}/`, {owner})
        .then(data => {
            data.displayOrder = slide.displayOrder;
            dispatch(slideListUpdateSuccess(slide.id, data));
            dispatch(setUIIdle());
        })
        .catch(err => {
            error_manager("Failed to change slide owner", err);
            dispatch(setUIIdle());
        });
}

export const loadTags = () => dispatch => {
    let url = `/api/get_all_tags/`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                dispatch({
                    type: DashboardConstants.INIT_TAGS,
                    tags: response.data.tags,
                });
            }
            else {
                console.log(response);
            }
        })
        .catch(err => {
            console.log(err);
        })
}

export const urlEncoder = (partsOfUrl) => {
    var encodedUrl = '?';
    if (partsOfUrl === undefined) {
        return encodedUrl;
    }
    if ('tags' in partsOfUrl) {
        var tags = partsOfUrl.tags;
        if (tags.length > 0) {
            encodedUrl += '&tags=';
            tags.map((tag) => encodedUrl += tag.replace('#', '%23') + '%20');
        }
    }
    if ('searches' in partsOfUrl) {
        var searches = partsOfUrl.searches;
        searches.map((search) => encodedUrl += '&search=' + encodeURIComponent(search));
    }
	if ('filters' in partsOfUrl) {
		var filters = partsOfUrl.filters;
		filters.forEach((filter) => {
			if (filter.includes('Export')){
				let name = filter.split('= ')[1];
				if(slideExportStatus.hasOwnProperty(name) === true) {
					encodedUrl += '&export_status=' + parseInt(slideExportStatus[name]);
				}
				else{
					encodedUrl += '&export_status=';
				}
			}
			if (filter.includes('Upload')){
				let name = filter.split('= ')[1];
				if(slideUploadStatus.hasOwnProperty(name) === true) {
					encodedUrl += '&upload_status=' + parseInt(slideUploadStatus[name]);
				}
				else{
					encodedUrl += '&upload_status=';
				}
			}
            if (filter.includes('Archive')){
                let name = filter.split('= ')[1];
                encodedUrl += '&archival_status=' + name;
            }
			if (filter.includes('Tiling')){
				let name = filter.split('= ')[1];
				if(slideTilingStatus.hasOwnProperty(name) === true) {
					encodedUrl += '&tiling_status=' + parseInt(slideTilingStatus[name]);
				}
				else{
					encodedUrl += '&tiling_status=';
				}
			}
			if (filter.includes('Device')){
				let device_id = filter.split('= ')[1];
				encodedUrl += '&device_id=' + parseInt(device_id);
			}
			if (filter.includes('Date')){
				var date = filter.split('= ')[1];
				date = date.split('/');
				encodedUrl += '&date__gte=' + date[0];
				encodedUrl += '&date__lte=' + date[1];
			}
            if (filter.includes('Specimen')){
                let name = filter.split('= ')[1];
                if(specimenType.hasOwnProperty(name) === true){
                    encodedUrl += '&specimen_type=' + encodeURIComponent(specimenType[name]);
                }else{
                    encodedUrl += '&specimen_type=';
                } 
            }
            if (filter.includes('ScanSpeed')){
                let name = filter.split('= ')[1];
                if(scanSpeed.hasOwnProperty(name) === true){
                    encodedUrl += '&scan_speed=' + encodeURIComponent(scanSpeed[name]);
                }else{
                    encodedUrl += '&scan_speed=';
                } 
            }
			encodedUrl += filter.includes('_Starred') ? '&starred=true' : '';
			encodedUrl += filter.includes('_Case not assigned') ? '&case_not_assigned=true' : '';
		});
	}
    if ('starred' in partsOfUrl) {
        encodedUrl += partsOfUrl.starred ? '&starred=true' : '';
    }
    if ('barcode_failed' in partsOfUrl) {
        encodedUrl += partsOfUrl.barcode_failed ? '&barcode_failed=true' : '';
    }
    if ('case_not_assigned' in partsOfUrl) {
        encodedUrl += partsOfUrl.case_not_assigned ? '&case_not_assigned=true' : '';
    }
    if ('ordering' in partsOfUrl) {
        encodedUrl += '&ordering=' + partsOfUrl.ordering;
    }
	if ('page' in partsOfUrl) {
		encodedUrl += '&page=' + partsOfUrl.page;
	}
    return encodedUrl;
}


export const deleteSlide = (value, urlState) => (dispatch) => {
    dispatch(slideListUpdateInitiated(value.id));
    let url = `/server/delete_scan/?morphle_id=${value.morphle_id}`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                dispatch(loadSlides(urlState));
                dispatch(slideListDeleteSuccess(value.id));
            } else {
                message.error(response.data);
                dispatch(slideListUpdateFailed(value.id, response));
            }
        })
        .catch(err => {
            message.error("Delete could not be Performed. Contact Admin.");
            dispatch(slideListUpdateFailed(value.id, err));
        });
};


function* pollForPollables(ids_to_poll) {
    while (cookie.load('token')) {
         try {
             if (isNull(ids_to_poll) || ids_to_poll.length === 0) return;
             let tilingStatusUrl = "/server/get_pollables/";
             const { data } = yield call(() => post_response(tilingStatusUrl, { 'ids_to_poll': ids_to_poll }));
             yield put(updatePollables(Object.assign({}, data)));

             const ids_to_stop_poll =   Object.keys(data).filter(id => !isTrue(data[id].keep_polling))
             yield put(removeSlidesFromPoller(ids_to_stop_poll));

             yield delay(2000);
         } catch (err) {
             console.log(err);
         }
     }
}

export const watchForPollables = function* (ids_to_poll) {
    yield race([
        call(pollForPollables, ids_to_poll),
    ]);
}

export const updatePollables = (data) => {
    return {
        type: SlideActions.UPDATE_POLLING,
        data: data
    }
}

export const startPollingForPollables = () => ({
    type: SlideActions.START_POLLING
})

export const stopPollingForPollables = () => ({
    type: SlideActions.STOP_POLLING
})

export const startTiling = (morphle_id, id) => dispatch => {
    dispatch(slideListUpdateInitiated(id));
    let url = `/server/start_tiling/?morphle_id=${morphle_id}`;
    get(url)
        .then(response => {
            dispatch(setSlideListFetched(id));
            dispatch(addSlidesToPoller(id));
            message.success("Tiling Started For: " + morphle_id);
        })
        .catch(err => {
            message.error("Error. Could not schedule for tiling.");
        });
}

export const startExport = (morphle_id, name, id) => dispatch => {
    dispatch(slideListUpdateInitiated(id));
    const user_id = cookie.load('user_id')
    let url = `/server/start_export/?morphle_id=${morphle_id}&user_id=${user_id}`;
    get(url)
        .then(res => {
            dispatch(setSlideListFetched(id));
            dispatch(addSlidesToPoller(id));
            message.success("Export Queued For: " + name);
        })
        .catch(err => {
            dispatch(setSlideListFetched(id));
            message.error("Error. Could not schedule for export.");
        });
}

export const cancelExport = (morphle_id, name, id) => dispatch => {
    dispatch(slideListUpdateInitiated(id));
    let url = `/server/cancel_export/?morphle_id=${morphle_id}`;
    get(url)
        .then(res => {
            dispatch(setSlideListFetched(id));
            message.success("Export Cancelled For: " + name);
        })
        .catch(err => {
            dispatch(setSlideListFetched(id));
            message.error("Error. Could not cancel export.");
        });
}

export const prioritizeExport = (morphle_id, name, id) => dispatch => {
    dispatch(slideListUpdateInitiated(id));
    let url = `/server/prioritize_export/?morphle_id=${morphle_id}`;
    get(url)
        .then(res => {
            dispatch(setSlideListFetched(id));
            dispatch(addSlidesToPoller(id));
            message.success("Prioritized Export: " + name);
        })
        .catch(err => {
            dispatch(setSlideListFetched(id));
            message.error("Error. Could not prioritize export.");
        });
}

export const startUpload = (morphle_id, id, upload_debug, upload_debug_only) => dispatch => {
    dispatch(slideListUpdateInitiated(id));
    let url = `/server/start_upload/?morphle_id=${morphle_id}&upload_debug=${upload_debug}&upload_debug_only=${upload_debug_only}`;
    get(url)
        .then(response => {
            dispatch(setSlideListFetched(id));
            dispatch(addSlidesToPoller(id));
            message.success("Upload Started For: " + morphle_id);
        })
        .catch(err => {
            if (err && err.response?.status === 400 && err.response?.data && err.response?.data?.includes("Max Upload Reached")) {
                message.error("Upload Limit Reached. Increase Limit or delete scans from cloud to upload.");
            } else {
                message.error("Upload Failed. Contact Admin.");
            }
	        dispatch(setSlideListFetched(id));
        });
}

export const startDebugUpload = (morphle_id, id) => dispatch => {
    dispatch(slideListUpdateInitiated(id));
    let url = `/start_debug_upload/?morphle_id=${morphle_id}`;
    get(url)
        .then(response => {
            dispatch(setSlideListFetched(id));
            dispatch(addSlidesToPoller(id));
            message.success("Upload Started For: " + morphle_id);
        })
        .catch(err => {
	        message.error("Upload Failed. Contact Admin.");
	        dispatch(setSlideListFetched(id));
	        console.log(err)
        });
}

export const getSlideStatus = (morphle_id, slot_id) => dispatch => {
    let url = `/server/slide_status/?morphle_id=`+morphle_id;
    get(url).then(data => dispatch(slideStatusFetched(slot_id, JSON.parse(data))))
        .catch(err => error_manager("Failed to check slide status", err))
}
